<script setup lang="ts">
// Footer component for Stack25 and other MEH-GAMES.COM games
import { computed } from 'vue';

// Get current year dynamically
const currentYear = computed(() => new Date().getFullYear());
</script>

<template>
  <footer class="bg-[#0c3b5f] text-white py-6 mt-auto">
    <div class="max-w-7xl mx-auto px-4">
      <div class="flex flex-col md:flex-row justify-between items-center">
        <div class="flex items-center mb-4 md:mb-0">
          <div class="w-6 h-6 relative mr-2">
            <div class="w-6 h-1 bg-green-500 absolute top-0 rounded-sm"></div>
            <div class="w-6 h-1 bg-green-500 absolute top-2 rounded-sm"></div>
            <div class="w-6 h-1 bg-green-500 absolute top-4 rounded-sm"></div>
          </div>
          <span class="font-bold text-lg">Stack25</span>
        </div>
        
        <div class="flex flex-col md:flex-row gap-4 md:gap-8 items-center mb-4 md:mb-0">
          <router-link to="/privacy" class="text-gray-300 hover:text-white text-sm">Privacy Policy</router-link>
          <router-link to="/terms" class="text-gray-300 hover:text-white text-sm">Terms of Use</router-link>
        </div>
        
        <div class="text-sm text-gray-300">
          &copy; {{ currentYear }} MEH-GAMES.COM - All Rights Reserved
        </div>
      </div>
    </div>
  </footer>
</template>
